module.exports = __webpack_public_path__ + "static/media/Home3.4715b0b5.png";